<div class="item-container"
  [class.disabled]="products.length == 0">
  <ol>
    <li class="menu-item">
      @if (!!selectedProduct) {
        <div> {{selectedProduct.display}} </div>
      }
      @if (!selectedProduct && products.length > 0) {
        <div> {{'SelectProduct'|translate:'ascent'}} </div>
      }
      @if (!selectedProduct && products.length == 0) {
        <div> {{'NoProducts'|translate:'ascent'}} </div>
      }
      <svg-icon [src]="iconSet.angleDown"
      class="eshava-ascent-svg"></svg-icon>
      <ol class="sub-menu">
        @for (product of products; track product) {
          <li class="menu-item"
            (click)="onProductSelected(product.value)">
            <div>{{ product.display }}</div>
          </li>
        }
      </ol>
    </li>
  </ol>
</div>